import React from 'react';
import '../MarsTheme.css';

const ProjectCard = ({ item, index }) => {
    const { type, title, description, tech, links, stats, platform, image } = item;

    // Render Logic based on Type
    const renderCardContent = () => {
        switch (type) {
            case 'app':
                return (
                    <>
                        {image && <div className="card-thumbnail" style={{ backgroundImage: `url(${image})` }}></div>}
                        <div className="card-content">
                            <div className="card-header">
                                <h3>{title}</h3>
                                {stats && <span className="badge-star">★ {stats.rating}</span>}
                            </div>
                            <p style={{ whiteSpace: 'pre-line' }}>{description.replace(/\\n/g, '\n')}</p>
                            <div className="tech-stack">
                                {tech.map(t => <span key={t} className="tech-tag">{t}</span>)}
                            </div>
                            <div className="card-footer">
                                {stats && <span className="stats-info">⬇ {stats.downloads}</span>}
                                <a href={links.playStore} className="btn-primary" target="_blank" rel="noreferrer">Play Store</a>
                            </div>
                        </div>
                    </>
                );

            case 'web':
                return (
                    <>
                        {image && <div className="card-thumbnail" style={{ backgroundImage: `url(${image})` }}></div>}
                        <div className="card-content">
                            <h3>{title}</h3>
                            <p style={{ whiteSpace: 'pre-line' }}>{description.replace(/\\n/g, '\n')}</p>
                            <div className="tech-stack">
                                {tech.map(t => <span key={t} className="tech-tag">{t}</span>)}
                            </div>
                            <div className="card-footer">
                                <a href={links.live} className="btn-primary" target="_blank" rel="noreferrer">Visit</a>
                                <a href={links.code} className="btn-secondary" target="_blank" rel="noreferrer">Code</a>
                            </div>
                        </div>
                    </>
                );

            case 'paper':
                return (
                    <div className="paper-layout">
                        <span className="icon-paper">📄</span>
                        <div>
                            <h3>{title}</h3>
                            <p className="paper-meta">Published: {item.date}</p>
                            <p style={{ whiteSpace: 'pre-line' }}>{description.replace(/\\n/g, '\n')}</p>
                            <a href={links.read} className="btn-text" target="_blank" rel="noreferrer">Read Paper &rarr;</a>
                        </div>
                    </div>
                );

            case 'extension':
            case 'package':
                return (
                    <>
                        <div className="card-header">
                            <h3>{title}</h3>
                            <span className="badge-platform">{platform}</span>
                        </div>
                        <p style={{ whiteSpace: 'pre-line' }}>{description.replace(/\\n/g, '\n')}</p>
                        <div className="card-footer">
                            {stats && <span className="stats-info">⬇ {stats.downloads}</span>}
                            <a href={links.marketplace || links.package} className="btn-primary" target="_blank" rel="noreferrer">Get it</a>
                        </div>
                    </>
                );

            case 'activity':
                const isEven = index % 2 === 0;
                const hasImage = !!image;
                const alignmentClass = !hasImage ? 'centered' : (isEven ? 'normal' : 'reverse');

                return (
                    <div className={`activity-card ${alignmentClass}`}>
                        {hasImage && <div className="activity-image" style={{ backgroundImage: `url(${image})` }}></div>}
                        <div className="activity-content">
                            <h3>{title}</h3>
                            <p style={{ whiteSpace: 'pre-line' }}>{description.replace(/\\n/g, '\n')}</p>
                            {/* <div className="tech-stack"></div>  Optional: Add stats here if needed */}
                            <a href={links.primary} className="btn-primary" target="_blank" rel="noreferrer">
                                {item.buttonText || "View Activity"}
                            </a>
                        </div>
                    </div>
                );

            default:
                // Generic / AI fallback
                return (
                    <>
                        {image && <div className="card-thumbnail" style={{ backgroundImage: `url(${image})` }}></div>}
                        <div className="card-content">
                            <h3>{title}</h3>
                            <p style={{ whiteSpace: 'pre-line' }}>{description.replace(/\\n/g, '\n')}</p>
                            {tech && (
                                <div className="tech-stack">
                                    {tech.map(t => <span key={t} className="tech-tag">{t}</span>)}
                                </div>
                            )}
                            <div className="card-footer">
                                {links.code && <a href={links.code} className="btn-secondary" target="_blank" rel="noreferrer">Code</a>}
                                {links.demo && <a href={links.demo} className="btn-primary" target="_blank" rel="noreferrer">Demo</a>}
                            </div>
                        </div>
                    </>
                );
        }
    };

    // If it's an activity, return it directly to avoid double wrapping (double padding/glass effect)
    if (type === 'activity') {
        return renderCardContent();
    }

    return (
        <div className={`glass-panel project-card fade-in ${image ? 'has-image' : ''}`}>
            {renderCardContent()}
        </div>
    );
};

export default ProjectCard;
